import React from "react";
import styles from "../css/Yuyue.css";
import { Button, Toast, Modal, ActionSheet } from "antd-mobile";
import { request } from "../request";
import { uploadOSS, checkFileName } from "../tools/uploadFile";
import { Header } from "./Introduce";
import _ from 'lodash'
import {
  showAlert,
  showAlert2,
  Add,
  Img,
  Loading,
  checkToekn,
} from "../tools/wechatBrower";
import teststyles from "../css/test.css";
import {
  checkPhone,
  checkEmail,
  checkZE,
  checkNum,
  checkNum2,
  checkNumber,
} from "../tools/wechatBrower";
import { Button as NButton } from "../tools/wechatBrower";



export const Item = ({
  left,
  rightP,
  value,
  id,
  disabled = false,
  onChange = (e) => {
  },
  onFocus = (e) => {
  },
  onBlur = (e) => {
  },
  type = "text",
  style = {},
  required = false
}) => {
  return (
    <div className={styles.item} id={id + "_div"} style={style}>
      <span className={styles.itemLeft}>
          {required ? <span style={{color:"red",fontSize:"16px"}}>* </span> : null}
          {left}
      </span>
      <input
        type={type}
        placeholder={rightP}
        className={styles.itemRight}
        value={value || ''}
        disabled={disabled ? true : false}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        id={id}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </div>
  );
};

const TextArea = ({ left, placeholder, render, id ,required = false}) => {
  return (
    <div className={styles.textarea}>
      <div className={styles.leftItem}>
        <span className={styles.textareaTitle}>
            {required ? <span style={{color:"red",fontSize:"16px"}}>* </span> : null}
            {left}
        </span>
        {render ? render() : null}
      </div>
      <textarea
        placeholder={placeholder}
        className={styles.textareaContent}
        id={id}
      />
    </div>
  );
};

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      info: {},
      display: false, // 禁止修改  当查看详情时 true  创建修改 false
      cctj: "",
      jggs: "",
      fplx: "",
      attach: "",
      yphs: "否",
      ypsl: "",
      fp_school: "校内",
      ypjs: "自主送样",
      invoice_id: "",
      receiving_information_id: "",
      recipient_list: [],
      uploaedImages: [
        // {
        //   url:
        //     "http://tsinghua-wechat-hq.oss-cn-beijing.aliyuncs.com/null_1620032180784_ales-krivec-4miBe6zg5r0-unsplash.jpg",
        //   filename: "ales-krivec-4miBe6zg5r0-unsplash.jpg",
        //   name: "null_1620032180784_ales-krivec-4miBe6zg5r0-unsplash.jpg",
        // },
      ],
      uploaedImages2: [],
      fp_list: [],
      sj_list: [],
      cunchu: false,
      jieguo: false,
      info_status: 0,
      page: 1,
      loading: true,
      subBu: true,
    };
  }

  componentDidMount() {
    ActionSheet.showActionSheetWithOptions({
      options: ['同意', '不同意'],
      title: '色谱与分离实验室测试服务条款',
      destructiveButtonIndex: 1,
      maskClosable: false,
      message: (
        <div>
          <div style={{ display: "block", marginTop: "10px", textAlign: 'initial', fontWeight: 'bolder' }}>
            <h4>
              亲爱的用户，感谢您的支持！为了让您获得更好的测试体验与准确的测试结果，请您认真阅读《色谱与分离实验室测试服务条款》，特向您说明如下：
            </h4>


          </div>
          <div style={{ display: "block", marginTop: "10px", textAlign: 'initial' }}>
            1.我们会遵循正当、合法、必要的原则收集和使用您的信息 <span style={{ color: "red" }}>，我们承诺不会将您的信息共享给第三方或用于您未同意的其他用途。</span>

          </div>
          <div style={{ display: "block", marginTop: "10px", textAlign: 'initial' }}>
            2.为使测试信息集中，<span style={{ color: "red" }}>所有的测试安排都是基于微信公众号提交的测试服务单为准，任何使用微信交流、电话沟通等方式所告知的消息均无效，</span>请理解。
          </div>
          <div style={{ display: "block", marginTop: "10px", textAlign: 'initial' }}>
            3.<span style={{ color: "red" }}>请按照测试需求的至少三倍量提供样品</span>。贵重样品（仅能进样或者处理一次）请接受由于操作失误造成的样品损失而无法得到结果的极小概率事件。
          </div>
          <div style={{ display: "block", marginTop: "10px", textAlign: 'initial' }}>
            4.测试周期：除液质联用外通常一周左右回复结果，样品数量多时需适当延长；如有加急需求请提前沟通。不排除仪器故障造成的测试延误，请理解。
          </div>
          <div style={{ display: "block", marginTop: "10px", textAlign: 'initial' }}>
            5.结果发送：测试结果提交后，微信公众号会发送提醒消息同时发送邮件，可点击进入相应的服务单或者登陆邮箱下载数据。<span style={{ color: "red" }}>请特别注意：该结果不含盖章测试报告，测试报告如需盖章请提前沟通。</span>
          </div>
          <div style={{ display: "block", marginTop: "10px", textAlign: 'initial' }}>
            6.如在测试后<span style={{ color: "red" }}>需要补充信息或者对结果有异议，请在服务方提交结果的两周内通过相应服务单下的“补充信息”提交您的需求</span>，该对话框仅在 <span style={{ color: "red" }}>提交结果的两周内显示，过期不候</span>。
          </div>
          <div style={{ display: "block", marginTop: "10px", textAlign: 'initial' }}>
            7.测试样品如需回收，请一定勾选相应的选项。<span style={{ color: "red" }}>请在测试结果提交后的两个周之内前往实验室取回样品或者主动联系服务方寄回样品</span>，费用自付，过期不候。已经消耗或者处理的样品无法回收。
          </div>
        </div>
      ),
    },
      (buttonIndex) => {
        if (buttonIndex == 1) {
          this.props.history.push("/");
        }
      });


    checkToekn();
    // this.checkCaches();
    request(
      "index/getInfo",
      {
        uid: localStorage.getItem("openid"),
        id: this.props.match.params.id,
      },
      ({ data }) => {
        if (data.code === 0) {
        } else {
          if (data.data) {

            // eslint-disable-next-line
            this.setState({ info: data.data, info_status: 1 }, () => {
              // console.log(typeof this.state.info);
            });
          }
        }
        this.setState({
          loading: false,
        });
      }
    );

    this.getRecipientLIst();
    this.getFpList();

    if (this.props.match.params.id) {
      request(
        "index/getOrder",
        {
          uid: localStorage.getItem("openid"),
          id: this.props.match.params.id,
        },
        ({ data }) => {
          data.code !== 1 && Toast.info("请求失败");
          this.setId("test_requirements", data.data.test_requirements);
          this.setId("ypjz", data.data.ypjz);
          this.setId("dcshl", data.data.dcshl);
          this.setId("ypxz", data.data.ypxz);
          this.setId("ffck", data.data.ffck);
          this.setId("ypsl", data.data.ypsl);
          if (data.data.ypsl) {
            this.state.ypsl = data.data.ypsl;
          }
          this.setId("kd", data.data.kd);
          this.setId("kddh", data.data.kddh);
          this.setId("remark", data.data.remark);
          console.log("data.data.attachfile", data.data.attachfiles);
          if (data.data.attachfiles) {
            let files = data.data.attachfiles.split(",");
            this.state.uploaedImages = files.map((element, index) => {
              let filename = element.split("_")[2];
              // console.log("filename", filename, element);

              let each = {
                url: element,
                filename: filename,
              };
              return each;
            });
          }
          if (data.data.cctj) {
            this.state.cunchu = true;
          }
          this.state.cctj = data.data.cctj;

          if (data.data.jggs) {
            this.state.jieguo = true;
          }
          this.state.jggs = data.data.jggs;

          this.state.ypjs = data.data.ypjs;

          this.state.yphs = data.data.yphs;
          this.state.fp_school = data.data.fp_school;
          this.state.invoice_id = data.data.invoice_id;
          this.state.pay_method = data.data.pay_method;
          this.state.pay_id = data.data.pay_id;
          this.state.pay_name = data.data.pay_name;
          this.state.funding_manager = data.data.funding_manager;

          this.state.receiving_information_id =
            data.data.receiving_information_id;
          this.setState();
        }
      );
    } else {
    }
  }

  getUserInfo() {
    let that = this;
    request(
      "index/getInfo",
      {
        uid: localStorage.getItem("openid"),
      },
      ({ data }) => {
        if (data.code === 0) {
        } else {
          if (data.data) {

            // eslint-disable-next-line
            this.setState({ info: data.data, info_status: 1 }, () => {
              console.log(this.state.info.topic_source === "重大军工项目")
            });
            setTimeout(() => {
              this.setState({ info: data.data })
            }, 1000);
          }
        }
      }
    );
  }

  getRecipientLIst() {
    let that = this;
    request(
      "index/getReceiving",
      {
        uid: localStorage.getItem("openid"),
      },
      ({ data }) => {
        // console.log(data, "!!!!!!!!!!!!!!!!!!!!!!");
        if (data.code === 1) {
          let use_recipient_list = data.data.info.map((item) => {
            let each = {};
            each.tag = item.tag;
            each.id = item.id;
            return each;
          });
          that.setState({
            recipient_list: use_recipient_list,
          });
        }
      }
    );
  }

  getFpList() {
    let that = this;
    request(
      "index/getInvoice",
      {
        uid: localStorage.getItem("openid"),
      },
      ({ data }) => {
        if (data.code === 1) {
          if (data.data.info) {
            let use_fp_list = data.data.info.map((item) => {
              item.label = item.company_name + "-" + item.type;
              item.value = item.id;
              return item;
            });
            that.setState(
              {
                fp_list: use_fp_list,
              },
              () => {
                console.log(that.state.fp_list);
              }
            );
          }
        }
      }
    );
  }

  // 收件信息展示
  sjxx() {
    return (
      this.state.yphs === "是" &&
      (this.state.recipient_list.length > 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
          onChange={(e) => {
            this.receiving_information_id(e);
          }}
        >
          {this.state.recipient_list.map((item, index) => (
            <label key={index} className={styles.font}>
              <input name="yphs2" type="radio" value={item.id || ''} />
              {item.tag}
            </label>
          ))}
          {this.state.recipient_list.length < 3 && (
            <Add
              click={() => {
                showAlert({
                  content: (
                    <div>
                      <div>
                        本次送检信息可暂存在“服务单”列表中，有效期7天，是否暂存？
                      </div>
                      <div>返回后请到“个人中心”“服务单”继续填写！</div>
                    </div>
                  ),
                  cancelFunc: () => {
                    this.props.history.push("/receivingAdd");
                  },
                  enterFunc: () => {
                    this.__zancun();
                    this.props.history.push("/receivingAdd");
                  },
                });
              }}
            />
          )}
        </div>
      ) : (
        <div
          style={{
            color: "#999999",
            fontSize: "0.7rem",
            textAlign: "center",
            margin: "10px 0",
          }}
        >
          请到个人中心页面,
          <span
            onClick={() => {
              showAlert({
                content: (
                  <div>
                    <div>
                      本次送检信息可暂存在“服务单”列表中，有效期7天，是否暂存？
                    </div>
                    <div>返回后请到“个人中心”“服务单”继续填写！</div>
                  </div>
                ),
                cancelFunc: () => {
                  this.props.history.push("/receivingAdd");
                },
                enterFunc: () => {
                  this.__zancun();
                  this.props.history.push("/receivingAdd");
                },
              });
            }}
            style={{ color: "rgb(174, 92, 201)" }}
          >
            去添加
          </span>
        </div>
      ))
    );
  }

  getId(name) {
    return document.getElementById(name)
      ? document.getElementById(name).value
      : "";
  }

  getBuyName(name) {
    let inputs = document.getElementsByName(name);
    let checd = [];
    for (let index = 0; index < inputs.length; index++) {
      if (inputs[index].checked) {
        checd.push(inputs[index]);
      }
    }
    if (checd.length > 0) {
      return checd[0].attributes.value.value;
    } else {
      return null;
    }
  }

  setItem(name) {
    if (this.getId(name)) {
      localStorage.setItem(name, this.getId(name));
    }
  }

  /**
   * 设置state 到缓存
   * @param {*} name
   */
  setStatItem(name) {
    switch (name) {
      case "topic_source":
        localStorage.setItem("topic_source", this.state.topic_source);
        break;
      case "cctj":
        localStorage.setItem("cctj", this.state.cctj);
        break;
      case "yphs":
        localStorage.setItem("yphs", this.state.yphs);
        break;

      case "jggs":
        localStorage.setItem("jggs", this.state.jggs);
        break;
      case "ypjs":
        localStorage.setItem("ypjs", this.state.ypjs);
        break;
      case "fp_school":
        localStorage.setItem("fp_school", this.state.fp_school);
        break;

      default:
        break;
    }
  }

  /**
   * 获取缓存 并赋值name=ID到对象
   * @param {*} name
   */
  setItemTo(name) {
    if (localStorage.getItem(name)) {
      this.setId(name, localStorage.getItem(name));
    }
  }

  setId(name, value) {
    document.getElementById(name).value = value;
  }


  /**
   * 把缓存 赋值到stat
   * @param {*} name
   */
  _setState(name) {
    if (localStorage.getItem(name)) {
      switch (name) {
        case "topic_source":
          // this.setState({
          //   topic_source: localStorage.getItem(name),
          // });
          this.state.topic_source = localStorage.getItem(name);
          this.setState();
          break;
        case "cctj":
          this.state.cctj = localStorage.getItem(name);
          this.state.cunchu = true;

          break;
        case "jggs":
          this.state.jggs = localStorage.getItem(name);
          this.state.jieguo = true;
          break;
        case "ypjs":
          this.state.ypjs = localStorage.getItem(name);

          break;

        case "yphs":
          this.state.yphs = localStorage.getItem(name);

          break;
        case "fp_school":
          this.state.fp_school = localStorage.getItem(name);

          break;

        case "fplx":
          this.setState({
            fplx: localStorage.getItem(name),
          });
          break;

        default:
          break;
      }
    }
  }

  yphs(e) {
    let value = e.target.value;
    this.setState({
      yphs: value,
    });
  }

  fp_school(e) {
    console.log("e.target.value", e.target.value, typeof e.target.value);
    let value = e.target.value;

    this.setState({
      fp_school: value,
    });
  }

  topic_source(e) {
    // console.log(e)
    // eslint-disable-next-line
    this.state.info.topic_source = e.target.value;
  }

  cctj(e) {
    console.log(e.target.value, "this.state.cctj");
    // eslint-disable-next-line
    this.state.cctj = e.target.value;
  }

  jggs(e) {
    // eslint-disable-next-line
    this.state.jggs = e.target.value;
  }

  ypjs(e) {
    this.setState({
      ypjs: e.target.value,
    });
  }

  fplx(e) {
    // eslint-disable-next-line
    this.state.fplx = e.target.value;
  }

  // uploadImage(e) {
  //   uploadFile(e, (res) => {
  //     if (res.code === 0) {
  //       Toast.fail(res.msg);
  //     } else {
  //       let filename = res.data.url.split("_")[1];
  //       let each = {
  //         url: res.data.url,
  //         filename: filename,
  //       };
  //       this.state.uploaedImages.push(each);
  //       this.setState();
  //     }
  //   });
  //   this.setState({
  //     isuploading: false,
  //   });
  // }

  FP() {
    return (
      (this.state.fp_list.length <= 0 ? (
        <div>
          <div
            style={{
              color: "#999999",
              fontSize: "0.7rem",
              textAlign: "center",
              margin: "10px 0",
            }}
          >
            请到个人中心页面,
            <span
              onClick={() => {
                showAlert({
                  content: (
                    <div>
                      <div>
                        本次送检信息可暂存在“服务单”列表中，有效期7天，是否暂存？
                      </div>
                      <div>返回后请到“个人中心”“服务单”继续填写！</div>
                    </div>
                  ),
                  cancelFunc: () => {
                    this.props.history.push("/FPAdd");
                  },
                  enterFunc: () => {
                    this.__zancun();
                    this.props.history.push("/FPAdd");
                  },
                });
              }}
              style={{ color: "rgb(174, 92, 201)" }}
            >
              去添加
            </span>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            marginTop: "5px"
          }}
          onChange={(e) => {
            this.fp(e);
          }}
        >
          {this.state.fp_list.map((item, index) => (
            <label key={index} className={styles.font} style={{marginRight:'8px'}}>
              <input name="fp" type="radio" value={item.id} defaultChecked={item.id === this.state.invoice_id} />
              {item.label}
            </label>
          ))}
          {this.state.fp_list.length < 3 && (
            <Add
              click={() => {
                showAlert({
                  content: (
                    <div>
                      <div>
                        本次送检信息可暂存在“服务单”列表中，有效期7天，是否暂存？
                      </div>
                      <div>返回后请到“个人中心”“服务单”继续填写！</div>
                    </div>
                  ),
                  cancelFunc: () => {
                    this.props.history.push("/FPAdd");
                  },
                  enterFunc: () => {
                    this.__zancun();
                    this.props.history.push("/FPAdd");
                  },
                });
              }}
            ></Add>
          )}
        </div>
      ))
    );
  }

  fp(e) {
    console.log(e.target.value, "e.target.value");
    this.state.invoice_id = e.target.value;
  }

  receiving_information_id(e) {
    this.state.receiving_information_id = e.target.value;
  }

  /**
   * 用户信息
   * @returns
   */
  info() {
    if (this.state.info) {
      return (
        <div className={styles.info}>
          <div className={styles.head}>
            <span className={styles.title}>个人信息</span>
            {/* <span className={styles.des}>该信息自动在个人中心中填充</span> */}
          </div>
          <Item
            left="姓名"
            rightP="请输入姓名"
            id="name"
            value={this.state.info.name || ''}
            onChange={(e) => {
              this.state.info.name = e;
              this.setState();
            }}
            onBlur={(e) => {
              let is_phone = checkZE(this.getId("name"));
              if (!is_phone) {
                Toast.fail("姓名只允许中英文,最多二十个字");
                return;
              }
            }}
            required={true}
          ></Item>
          <Item
            left="手机号"
            rightP="请输入手机号"
            id="phone"
            value={this.state.info.phone || ''}
            onChange={(e) => {
              if (checkNum(e)) {
                this.state.info.phone = e;
                this.setState();
              }
            }}
            onBlur={(e) => {
              let is_phone = checkPhone(this.state.info.phone);
              if (!is_phone) {
                Toast.fail("手机号格式不正确");
                return;
              }
            }}
            required={true}
          ></Item>
          <Item
            left="电子邮箱"
            rightP="请输入电子邮箱"
            id="email"
            value={this.state.info.email || ''}
            onChange={(e) => {
              this.state.info.email = e;
              this.setState();
            }}
            onBlur={(e) => {
              let is_phone = checkEmail(this.getId("email"));
              if (!is_phone) {
                Toast.fail("邮箱格式不正确");
                return;
              }
              if (this.getId("email").length > 40) {
                Toast.fail("邮箱最多40个字符");
                return;
              }
            }}
            required={true}
          ></Item>
          <Item
            left="所在单位"
            rightP="请输入所在单位"
            id="company_name"
            value={this.state.info.company_name || ''}
            onChange={(e) => {
              this.state.info.company_name = e;
              this.setState();
            }}
            required={true}
          ></Item>
          <Item
            left="单位通信地址"
            rightP="请输入单位通信地址"
            id="company_address"
            value={this.state.info.company_address || ''}
            onChange={(e) => {
              this.state.info.company_address = e;
              this.setState();
            }}
          ></Item>
        </div>
      );
    } else {
      return (
        <div className={styles.info}>
          <div className={styles.head}>
            <span className={styles.title}>个人信息</span>
            {/* <span className={styles.des}>该信息自动在个人中心中填充</span> */}
          </div>
          <Item
            left="姓名"
            rightP="请输入姓名"
            id="name"
            onBlur={(e) => {
              let is_phone = checkZE(this.getId("name"));
              if (!is_phone) {
                Toast.fail("姓名只允许中英文,最多二十个字");
                return;
              }
            }}
          ></Item>
          <Item
            left="手机号"
            rightP="请输入手机号"
            id="phone"
            onBlur={(e) => {
              let is_phone = checkPhone(this.getId("phone"));
              if (!is_phone) {
                // let node = document.getElementById("phone_div");
                // node.style.border = "solid 1px red";
                // console.log("node", node);
                Toast.fail("手机号格式不正确");
                return;
              }
            }}
          ></Item>
          <Item
            left="电子邮箱"
            rightP="请输入电子邮箱"
            id="email"
            onBlur={(e) => {
              let is_phone = checkEmail(this.getId("email"));
              if (!is_phone) {
                Toast.fail("邮箱格式不正确");
                return;
              }
              if (this.getId("email").length > 40) {
                Toast.fail("邮箱最多40个字符");
                return;
              }
            }}
          ></Item>
          <Item
            left="所在单位"
            rightP="请输入所在单位"
            id="company_name"
          ></Item>
          <Item
            left="单位通信地址"
            rightP="请输入单位通信地址"
            id="company_address"
          ></Item>
        </div>
      );
    }
  }

  /**
   * 课题信息
   * @returns
   */
  subject_information() {
    return (
      <div className={styles.info}>
        <div className={styles.head}>
          <span className={styles.title}>课题信息</span>
        </div>
        <Item
          left="课题(经费)负责人"
          rightP="请输入课题负责人"
          id="topic_leader"
          onFocus={(e) => {
            console.log(e, "~~~~~~~~~~~~~~");
          }}
          onBlur={(e) => {
            let is_topic_leader = checkZE(this.getId("topic_leader"));
            if (!is_topic_leader) {
              Toast.fail("课题负责人只允许中英文,最多十个字");
              return;
            }
          }}
          value={this.state.info.topic_leader || ''}
          onChange={(e) => {
            this.state.info.topic_leader = e;
            this.setState();
          }}
          required={true}
        ></Item>
        <Item
          left="课题名称"
          rightP="请输入课题名称"
          id="topic_name"
          onBlur={(e) => {
            let is_topic_name = checkZE(this.getId("topic_name"));
            if (!is_topic_name) {
              Toast.fail("课题名称只允许中英文,最多十个字");
              return;
            }
          }}
          value={this.state.info.topic_name || ''}
          onChange={(e) => {
            this.state.info.topic_name = e;
            this.setState();
          }}
          required={true}
        ></Item>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <label className={styles.font}>* 课题来源</label>

        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            marginLeft: "20px"
          }}

          onChange={(e) => {
            let info = _.cloneDeep(this.state.info)
            info.topic_source = e.target.value

            this.setState({
              info: info
            }, () => {
              console.log(this.state.info)
            })
          }}
        >
          <label className={styles.font} style={{ width: '50%' }}>
            <input
              name="Fruit"
              type="radio"
              value="国家重大研发计划"
              checked={this.state.info.topic_source == "国家重大研发计划"}
            />
            国家重大研发计划
          </label>
          <label className={styles.font} style={{ width: '50%' }}>
            <input
              name="Fruit"
              type="radio"
              value="重大军工项目"
              checked={this.state.info.topic_source === "重大军工项目"}

            />
            重大军工项目
          </label>
          <label className={styles.font} style={{ width: '50%' }}>
            <input
              name="Fruit"
              type="radio"
              value="科技支撑计划"
              checked={this.state.info.topic_source == "科技支撑计划"}
            />
            科技支撑计划
          </label>
          <label className={styles.font} style={{ width: '50%' }}>
            <input
              name="Fruit"
              type="radio"
              value="国家产学研项目"
              checked={this.state.info.topic_source == "国家产学研项目"}
            />
            国家产学研项目
          </label>
          <label className={styles.font} style={{ width: '50%' }}>
            <input
              name="Fruit"
              type="radio"
              value="国家自然科学基金"
              checked={
                this.state.info.topic_source == "国家自然科学基金"
              }
            />
            国家自然科学基金
          </label>
          <label className={styles.font} style={{ width: '50%' }}>
            <input
              name="Fruit"
              type="radio"
              value="其他来源"
              checked={this.state.info.topic_source == "其他来源"}
            />
            其他来源
          </label>
        </div>
      </div>
    );
  }

  /**
   * 样品信息
   * @returns
   */
  sample() {
    return (
      <div className={styles.info}>
        <div className={styles.head}>
          <span className={styles.title}>样品信息</span>
          <span className={styles.des}>
            请务必提前查看相关仪器的
            <span
              onClick={() => {
                showAlert({
                  content: (
                    <div>
                      <div>
                        本次送检信息可暂存在“服务单”列表中，有效期7天，是否暂存？
                      </div>
                      <div>返回后请到“个人中心”“服务单”继续填写！</div>
                    </div>
                  ),
                  cancelFunc: () => {
                    this.props.history.push("/test_know");
                  },
                  enterFunc: () => {
                    this.__zancun();
                    this.props.history.push("/test_know");
                  },
                });
              }}
              style={{ color: "rgb(174, 92, 201)" }}
            >
              送检须知
            </span>
          </span>
        </div>
        <TextArea
          id="test_requirements"
          left="测试需求"
          placeholder="请详细描述您的测试需求。"
          required={true}
        ></TextArea>
        <TextArea
          id="ypjz"
          left="样品基质"
          placeholder="请详细描述样品信息，如样品状态（固体、液体、悬浊液）、组成及其大致含量。如乙腈溶液、20%的甲醇水溶液、2%硝酸水溶液、PBS溶液、土壤、XX食品样品、XX植物样品。"
          required={true}
        ></TextArea>
        <TextArea
          id="dcshl"
          left="目标物含量"
          placeholder="请提供目标物的大致含量，如X %，X mg/L，X mg/Kg（可以是一个范围或者数量级），或者常量分析、微量分析、痕量分析等，请不要填写未知或者不确定。"
          required={true}
        ></TextArea>
        <TextArea
          id="ypxz"
          left="样品性质"
          placeholder="请尽可能指出以下信息：毒性、危险性、不稳定性等，或者潜在影响测试的因素，如样品中含有高含量非待测物质。"
          required={true}
        ></TextArea>
        <TextArea
          id="ffck"
          left="方法参考与建议"
          placeholder="请提供可参考的前处理和测试方法，可在下方上传标记颜色的附件；可与实验室负责人韩强沟通，并将沟通后的信息详细的填在此处。"
          required={true}
        ></TextArea>
        <Item
          left="样品数量"
          rightP="请输入样品数量"
          id="ypsl"
          onChange={(e) => {
            if (checkNumber(e) || !e) {
              this.state.ypsl = e;
              this.setState();
            }
          }}
          value={this.state.ypsl || ''}
          onBlur={() => {
            if (!checkNumber(this.state.ypsl)) {
              Toast.fail("样品数量不是正整数");
            }
          }}
          required={true}
        ></Item>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <label className={styles.font}>
          <span style={{color:"red",fontSize:"16px"}}>* </span>    
          储存条件
          </label>

        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            marginLeft: '20px'
          }}

          onChange={(e) => {
            let cctj = e.target.value

            this.setState({
              cctj: cctj
            })
          }}
        >
          <label className={styles.font} style={{ width: "25%" }}>
            <input
              name="cctj"
              type="radio"
              value="室温"
              checked={this.state.cctj === "室温"}
            />
            室温{" "}
          </label>
          <label className={styles.font} style={{ width: "25%" }}>
            <input
              name="cctj"
              type="radio"
              value="冷藏"
              checked={this.state.cctj === "冷藏"}
            />
            冷藏{" "}
          </label>
          <label className={styles.font} style={{ width: "25%" }}>
            <input
              name="cctj"
              type="radio"
              value="-20冷冻"
              checked={this.state.cctj === "-20冷冻"}
            />
            -20冷冻{" "}
          </label>
          <label className={styles.font} style={{ width: "25%" }}>
            <input
              name="cctj"
              type="radio"
              value="-80冷冻"
              checked={this.state.cctj === "-80冷冻"}
            />
            -80冷冻{" "}
          </label>
        </div>
      </div>
    );
  }


  payInfo() {
    let that = this
    if (this.state.pay_method === "校内平台") {
      return (
        <div>
          <div style={{
            marginTop: '5px',
            height: '1.866667rem',
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold'
          }} className={styles.textareaTitle}>
            请提供扣款从用户的证件号和主用户姓名
          </div>
          <Item
            left="主用户姓名"
            rightP="请输入主用户姓名"
            id="pay_name"
            onChange={(e) => {
              that.state.pay_name = e;
              that.setState();
            }}
            value={that.state.pay_name || ''}
            onBlur={(e) => {
              let res = checkZE(that.getId("pay_name"));
              if (!res) {
                Toast.fail("主用户姓名只允许中英文,最多二十个字");
                return;
              }
            }}
            required={true}
          ></Item>

          <Item
            left="从用户证件号"
            rightP="请输入从用户证件号"
            id="pay_id"
            onChange={(e) => {
              that.state.pay_id = e;
              that.setState();
            }}
            value={that.state.pay_id || ''}
            onBlur={(e) => {
              let res = checkNum2(that.getId("pay_id"));
              if (!res) {
                Toast.fail("从用户证件号只允许十个数字");
                return;
              }
            }}
            required={true}
          ></Item>
        </div>
      )
    } else if (this.state.pay_method === "校内转账") {
      return (
        <div style={{
          marginTop: '5px',
          height: '1.866667rem',
          display: 'flex',
          alignItems: 'center',
          fontWeight: 'bold'
        }} className={styles.textareaTitle}>
          请在结果上传后联系实验室缴费
        </div>
      )
    } else if (this.state.pay_method === "中心预存") {
      return (
        <div>

          <div style={{
            marginTop: '5px',
            height: '1.866667rem',
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold'
          }} className={styles.textareaTitle}>
            请提供经费负责人
          </div>
          <Item
            left="经费负责人"
            rightP="请输入经费负责人"
            id="funding_manager"
            onChange={(e) => {
              that.state.funding_manager = e;
              that.setState();
            }}
            value={that.state.funding_manager || ''}
            onBlur={(e) => {
              let res = checkZE(that.getId("funding_manager"));
              if (!res) {
                Toast.fail("经费负责人只允许中英文,最多二十个字");
                return;
              }
            }}
            required={true}
          ></Item>

        </div>
      )
    } else if (this.state.pay_method === "校外发票") {
      return this.FP();
    } else {
      return ('');
    }
  }

  pay_method_val(e) {

    let value = e.target.value;
    this.setState({
      pay_method: value,
    });
    console.log(this.state.pay_method)
    console.log(this.state.fp_school)
  }


  // 付款方式
  payMethod() {



    return (
      <div>
        <div
          style={{ display: "flex" }}
          onChange={(e) => {
            this.pay_method_val(e);
          }}
          className={styles.radioFull}
        >
          <div >
            <input
              type="radio"
              name="pay_method"
              defaultChecked={this.state.pay_method === "校内平台"}
              checked={this.state.pay_method === "校内平台"}
              value="校内平台"
            />
            <span className={styles.pText}>校内平台</span>
          </div>


          <div >
            <input
              type="radio"
              name="pay_method"
              value="校内转账"
              defaultChecked={this.state.pay_method === "校内转账"}
              checked={this.state.pay_method === "校内转账"}
            />
            <span className={styles.pText}>校内转账</span>
          </div>

          <div>
            <input
              type="radio"
              name="pay_method"
              value="校外发票"
              defaultChecked={this.state.pay_method === "校外发票"}
              checked={this.state.pay_method === "校外发票"}
            />
            <span className={styles.pText}>校外发票</span>
          </div>

          <div >
            <input
              type="radio"
              name="pay_method"
              value="中心预存"
              defaultChecked={this.state.pay_method === "中心预存"}
              checked={this.state.pay_method === "中心预存"}
            />
            <span className={styles.pText}>中心预存</span>
          </div>


        </div>

        {this.payInfo()}
      </div>
    )
  }



  /**
   * 上传附件
   * @return
   */
  upload() {
    return (
      <div className={styles.info}>
        <div className={styles.head}>
          <span className={styles.title}>上传附件</span>
          {/* <span className={styles.des}>该处可上传图片、word、PDF文件</span> */}
        </div>

        <div>
          <p
            style={{
              marginTop: "0.3rem",
              lineHeight: "1rem",
              textAlign: "left",
            }}
          >
            请上传包含分析方法（颜色标记）的图片、WORD或者PDF文件，每个文件小于10M。
          </p>
        </div>

        <div className={teststyles["upload-container"]}>
          <input
            type="file"
            name="image"
            className={teststyles["upload-input"]}
            onChange={async (e) => {
              let file = e.target.files[0];
              console.error("file", file);
              if (!file) {
                return;
              }
              this.setState({
                loading: true,
              });
              if (this.state.uploaedImages.length < 3) {
                let filename = checkFileName(file.name);
                let res = 1;
                this.state.uploaedImages.forEach((element) => {
                  if (element.filename === filename) {
                    Toast.fail("不得重复上传");
                    res = 0;
                    this.setState({
                      loading: false,
                    });
                  }
                });

                if (res) {
                  let res = await uploadOSS(file);
                  if (res.code === 1) {
                    let each = {
                      url: res.data.url,
                      filename: res.data.filename,
                      name: res.data.name,
                    };
                    this.state.uploaedImages.push(each);
                    this.setState();
                  }
                  this.setState({
                    loading: false,
                  });
                }
              } else {
                this.setState({
                  loading: false,
                });
                Toast.fail("最多上传三张文件");
              }
            }}
          />
          <Button type="primary">上传文件</Button>
        </div>

        <div className={styles.chusedImage}>
          {this.state.uploaedImages.map((item, index) => (
            <Img
              item={item}
              onClick={() => {
                this.state.uploaedImages.splice(index, 1);
                this.setState();
              }}
            ></Img>
          ))}
        </div>
      </div>
    );
  }


  /**
   * 上传样品
   * @return
  */
  uploadProduct() {
    return (
      <div className={styles.info}>
        <div className={styles.head}>
          <span className={styles.title}>上传样品图片</span>
          {/* <span className={styles.des}>该处可上传图片、word、PDF文件</span> */}
        </div>

        <div>
          <p
            style={{
              marginTop: "0.3rem",
              lineHeight: "1rem",
              textAlign: "left",
            }}
          >
            <span style={{ color: "red", fontSize: "16px" }}>* </span>
            请务必上传样品照片，照片中请包含样品标记。
          </p>
        </div>

        <div className={teststyles["upload-container"]}>
          <input
            type="file"
            name="image"
            className={teststyles["upload-input"]}
            onChange={async (e) => {
              let file = e.target.files[0];
              console.error("file", file);
              if (!file) {
                return;
              }
              this.setState({
                loading: true,
              });
              if (this.state.uploaedImages2.length < 3) {
                let filename = checkFileName(file.name);
                let res = 1;
                this.state.uploaedImages2.forEach((element) => {
                  if (element.filename === filename) {
                    Toast.fail("不得重复上传");
                    res = 0;
                    this.setState({
                      loading: false,
                    });
                  }
                });

                if (res) {
                  let res = await uploadOSS(file);
                  if (res.code === 1) {
                    let each = {
                      url: res.data.url,
                      filename: res.data.filename,
                      name: res.data.name,
                    };
                    this.state.uploaedImages2.push(each);
                    this.setState();
                  }
                  this.setState({
                    loading: false,
                  });
                }
              } else {
                this.setState({
                  loading: false,
                });
                Toast.fail("最多上传三张文件");
              }
            }}
          />
          <Button type="primary">上传文件</Button>
        </div>

        <div className={styles.chusedImage}>
          {this.state.uploaedImages2.map((item, index) => (
            <Img
              item={item}
              key={index}
              onClick={() => {
                this.state.uploaedImages2.splice(index, 1);
                this.setState();
              }}
            ></Img>
          ))}
        </div>
      </div>
    );
  }
  /**
   * 其他信息
   * @returns
   */
  other() {
    return (
      <div className={styles.info}>
        <div className={styles.head}>
          <span className={styles.title}>其他信息</span>
          <span className={styles.des}></span>
        </div>
        {/* <div className={styles.leftItem}>
          <span className={styles.textareaTitle}>* 结果格式</span>
          <label
            className={styles.font}
            style={{
              color: "#ae5cc9",
              display: this.state.jieguo && "none",
            }}
            onClick={() => {
              this.setState({
                jieguo: true,
              });
            }}
          >
            请选择
          </label>
        </div>
        {this.state.jieguo && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
            }}
            onChange={(e) => {
              this.jggs(e);
            }}
          >
            <label className={styles.font}>
              <input
                name="jggs"
                type="radio"
                value="测试信息+PDF文件"
                defaultChecked={this.state.jggs === "测试信息+PDF文件"}
              />
              测试信息+PDF文件{" "}
            </label>
            <label className={styles.font}>
              <input
                name="jggs"
                type="radio"
                value="典型样品的画图数据，请在备注中说明"
                defaultChecked={
                  this.state.jggs === "典型样品的画图数据，请在备注中说明"
                }
              />
              典型样品的画图数据，请在备注中说明{" "}
            </label>
            <label className={styles.font}>
              <input
                name="jggs"
                type="radio"
                value="数据源文件，需有相应软件"
                defaultChecked={this.state.jggs === "数据源文件，需有相应软件"}
              />
              数据源文件，需有相应软件
            </label>
            <label className={styles.font}>
              <input
                name="jggs"
                type="radio"
                value="其他请在备注中补充"
                defaultChecked={this.state.jggs === "其他请在备注中补充"}
              />
              其他请在备注中补充
            </label>
          </div>
        )} */}

        <div className={styles.leftItem}>
          <label className={styles.textareaTitle}>
          <span style={{color:"red",fontSize:"16px"}}>* </span>    
          送样方式
          </label>
          <div
            onChange={(e) => {
              this.ypjs(e);
            }}
            className={styles.radioRight}

          >
            <div className={styles.radioRightItem}>
              <input
                type="radio"
                name="ypjs"
                value="自主送样"
                checked={this.state.ypjs === "自主送样"}
              />
              <span className={styles.pText}>自主送样</span>
            </div>

            <div className={styles.radioRightItem}>
              <input
                type="radio"
                name="ypjs"
                value="快递邮寄"
                checked={this.state.ypjs === "快递邮寄"}
              />
              <span className={styles.pText}>快递邮寄</span>
            </div>

          </div>
        </div>

        <div
          className={styles.item}
          style={{
            display: this.state.ypjs === "自主送样" && "none",
          }}
        >
          <span className={styles.itemLeft2}>快递信息</span>
          <input
            placeholder={"请输入快递公司"}
            className={styles.itemRight}
            id={"kd"}
          ></input>
        </div>
        <div
          className={styles.item}
          style={{
            display: this.state.ypjs === "自主送样" && "none",
          }}
        >
          <span className={styles.itemLeft2}>运单号</span>
          <input
            placeholder={"请输入运单号"}
            className={styles.itemRight}
            id={"kddh"}
          ></input>
        </div>

        <div className={styles.leftItem}>
          <span className={styles.textareaTitle}><span style={{color:"red",fontSize:"16px"}}>* </span>样品回收</span>
                              
          <div
            style={{ display: "flex" }}
            onChange={(e) => {
              this.yphs(e);
            }}
            className={styles.radioRight}
          >
            <div className={styles.radioRightItem}>
              <input
                type="radio"
                name="yphs"
                checked={this.state.yphs === "否"}
                value="否"

              />
              <span className={styles.pText}>否</span>

            </div>

            <div className={styles.radioRightItem}>
              <input
                type="radio"
                name="yphs"
                value="是"
                checked={this.state.yphs === "是"}
              />
              <span className={styles.pText}>是</span>
            </div>


          </div>
        </div>
        {this.sjxx()}

        {/* <div className={styles.leftItem}>
          <span className={styles.textareaTitle}>* 发票信息</span>
          <div
            style={{ display: "flex" }}
            onChange={(e) => {
              this.fp_school(e);
            }}
            className={styles.radioRight}
          >
            <div className={styles.radioRightItem}>
              <input
                type="radio"
                name="fp_school"
                checked={this.state.fp_school === "校内"}
                value="校内"
              />
              <span className={styles.pText}>校内</span>
            </div>


            <div className={styles.radioRightItem}>
              <input
                type="radio"
                name="fp_school"
                value="校外"
                checked={this.state.fp_school === "校外"}
              />
              <span className={styles.pText}>校外</span>
            </div>

          </div>
        </div>
        {this.FP()} */}

        <div className={styles.leftItem}>

          <span className={styles.textareaTitle}><span style={{color:"red",fontSize:"16px"}}>* </span>付款方式</span>
          

        </div>
        {this.payMethod()}



        <div className={styles.textarea}>
          <div className={styles.leftItem}>
            <span className={styles.textTitle}>备注</span>
          </div>
          <textarea
            placeholder={"请输入备注信息。"}
            className={styles.textareaContent}
            style={{ height: "57px" }}
            id="remark"
          ></textarea>
        </div>
      </div>
    );
  }

  __zancun() {
    this.setState({
      loading: true,
    });
    let attachfiles = "";

    if (this.state.uploaedImages) {
      attachfiles = this.state.uploaedImages
        .map((obj, index) => {
          return obj.url;
        })
        .join(",");
    }

    let product_images = "";
    if (this.state.uploaedImages2.length>=1) {
        product_images = this.state.uploaedImages2
            .map((obj, index) => {
                return obj.url;
            })
            .join(",");
    }

    request(
      "index/order",
      {
        type: 0,
        uid: localStorage.getItem("openid"),
        name: this.getId("name"),
        phone: this.getId("phone"),
        email: this.getId("email"),
        company_name: this.getId("company_name"),
        topic_leader: this.getId("topic_leader"),
        topic_name: this.getId("topic_name"),
        topic_source: this.state.info.topic_source,

        test_requirements: this.getId("test_requirements"),
        ypjz: this.getId("ypjz"),
        dcshl: this.getId("dcshl"),
        ypxz: this.getId("ypxz"),
        ffck: this.getId("ffck"),
        ypsl: this.state.ypsl,
        cctj: this.getBuyName("cctj"),
        attachfiles: attachfiles,
        product_images: product_images,
        jggs: this.getBuyName("jggs"),
        ypjs: this.state.ypjs,
        kd: this.getId("kd"),
        kddh: this.getId("kddh"),
        yphs: this.state.yphs,
        fp_school: this.state.fp_school,
        invoice_id: this.state.invoice_id,
        receiving_information_id: this.state.receiving_information_id,
        remark: this.getId("remark"),

        pay_method: this.state.pay_method,
        pay_id: this.getId("pay_id"),
        pay_name: this.getId("pay_name"),
        funding_manager: this.getId("funding_manager"),
      },
      ({ data }) => {
        this.setState({
          loading: false,
          subBu: true,
        });
        if (data.code === 1) {
          // Toast.success("创建成功");
        } else {
          Toast.fail("创建失败");
        }
      },
      (err) => {
        this.setState({
          loading: false,
          subBu: true,
        });
        Toast.fail("创建失败,接口错误");
      }
    );
  }

  _zancun() {
    if (this.state.subBu) {
      this.state.subBu = false;

      let attachfiles = "";

      if (this.state.uploaedImages) {
        attachfiles = this.state.uploaedImages
          .map((obj, index) => {
            return obj.url;
          })
          .join(",");
      }

      let product_images = "";
      if (this.state.uploaedImages2.length>=1) {
          product_images = this.state.uploaedImages2
              .map((obj, index) => {
                  return obj.url;
              })
              .join(",");
      }

      request(
        "index/order",
        {
          type: 0,
          uid: localStorage.getItem("openid"),
          name: this.getId("name"),
          phone: this.getId("phone"),
          email: this.getId("email"),
          company_name: this.getId("company_name"),
          topic_leader: this.getId("topic_leader"),
          topic_name: this.getId("topic_name"),
          topic_source: this.state.info.topic_source,

          test_requirements: this.getId("test_requirements"),
          ypjz: this.getId("ypjz"),
          dcshl: this.getId("dcshl"),
          ypxz: this.getId("ypxz"),
          ffck: this.getId("ffck"),
          ypsl: this.state.ypsl,
          cctj: this.getBuyName("cctj"),
          attachfiles: attachfiles,
          product_images: product_images,
          jggs: this.getBuyName("jggs"),
          ypjs: this.state.ypjs,
          kd: this.getId("kd"),
          kddh: this.getId("kddh"),
          yphs: this.state.yphs,
          fp_school: this.state.fp_school,
          invoice_id: this.state.invoice_id,
          receiving_information_id: this.state.receiving_information_id,
          remark: this.getId("remark"),

          pay_method: this.state.pay_method,
          pay_id: this.getId("pay_id"),
          pay_name: this.getId("pay_name"),
          funding_manager: this.getId("funding_manager"),
        },
        ({ data }) => {
          this.setState({
            loading: false,
            subBu: true,
          });
          if (data.code === 1) {
            Toast.success("创建成功");

            setTimeout(() => {
              this.props.history.push("/orderlist");
            }, 500);
          } else {
            Toast.fail("创建失败");
          }
        },
        (err) => {
          this.setState({
            loading: false,
            subBu: true,
          });
          Toast.fail("创建失败,接口错误");
        }
      );
    }
  }

  /**
   * 暂存按钮
   * @returns
   */
  zancun() {
    return (
      <NButton
        style={{ width: "88%", marginLeft: "auto", marginRight: "auto" }}
        onClick={() => {
          this.setState({
            loading: true,
          });

          showAlert2({
            content: (
              <div>
                <div>
                  本次送检信息可暂存在“服务单”列表中，有效期7天，是否暂存？
                </div>
              </div>
            ),
            cancelFunc: () => {
              this.setState({
                loading: false,
                subBu: true,
              });
            },
            enterFunc: () => {
              this._zancun();
            },
          });
        }}
        title="暂存"
      />
    );
  }

  _sub() {

    if (
      Boolean(
        this.getId("test_requirements") &&
        this.getId("ypjz") &&
        this.getId("dcshl") &&
        this.getId("ypxz") &&
        this.getId("ffck") &&
        this.state.ypsl &&
        this.state.cctj && // 存储条件
        // this.state.jggs && // 结果格式
        this.state.ypjs && // 送样方式
        this.state.yphs && // 样品回收
        this.state.fp_school // 样品回收
      )
    ) {
      let attachfiles = "";

      if (this.state.uploaedImages) {
        attachfiles = this.state.uploaedImages
          .map((obj, index) => {
            return obj.url;
          })
          .join(",");
      }
      let product_images = "";
      if (this.state.uploaedImages2.length>=1) {
        product_images = this.state.uploaedImages2
          .map((obj, index) => {
            return obj.url;
          })
          .join(",");
      }else{
        Toast.fail("请上传样品图片");
        this.setState({
          loading: false,
          subBu: true,
        });
        return;
      }
      if (this.state.yphs === "是" && !this.state.receiving_information_id) {
        Toast.fail("请选择收件信息");
        this.setState({
          loading: false,
          subBu: true,
        });
        return;
      }

      if (this.state.pay_method === "校内平台" && (!this.state.pay_id || !this.state.pay_name)) {
        Toast.fail("请提供证件号和姓名");
        this.setState({
          loading: false,
          subBu: true,
        });
        return;
      }

      if (this.state.pay_method !== "校内平台") {
        this.state.pay_id = ""
        this.state.pay_name = ""
      }

      if (this.state.pay_method == "校外发票" && (!this.state.invoice_id)) {
        Toast.fail("请选择发票");
        this.setState({
          loading: false,
          subBu: true,
        });
        return;
    }


      if (this.state.pay_method === "中心预存" && (!this.state.funding_manager)) {
        Toast.fail("请提供经费负责人");
        this.setState({
          loading: false,
          subBu: true,
        });
        return;
      }

      request(
        "index/order",
        {
          uid: localStorage.getItem("openid"),

          name: this.getId("name"),
          phone: this.getId("phone"),
          email: this.getId("email"),
          company_name: this.getId("company_name"),
          topic_leader: this.getId("topic_leader"),
          topic_name: this.getId("topic_name"),
          topic_source: this.state.info.topic_source,

          test_requirements: this.getId("test_requirements"),
          ypjz: this.getId("ypjz"),
          dcshl: this.getId("dcshl"),
          ypxz: this.getId("ypxz"),
          ffck: this.getId("ffck"),
          ypsl: this.state.ypsl,
          cctj: this.getBuyName("cctj"),
          attachfiles: attachfiles,
          product_images: product_images,
          jggs: this.getBuyName("jggs"),
          ypjs: this.state.ypjs,
          kd: this.getId("kd"),
          kddh: this.getId("kddh"),
          yphs: this.state.yphs,
          fp_school: this.state.fp_school,
          invoice_id: this.state.invoice_id,
          receiving_information_id: this.state.receiving_information_id,
          remark: this.getId("remark"),


          pay_method: this.state.pay_method,
          pay_id: this.getId("pay_id"),
          pay_name: this.getId("pay_name"),
          funding_manager: this.getId("funding_manager"),
        },
        ({ data }) => {
          this.setState({
            loading: false,
          });
          if (data.code === 1) {
            Toast.success("创建成功");
            setTimeout(() => {
              this.props.history.push("/orderlist");
            }, 500);
          } else {
            Toast.fail("创建失败");
          }
        },
        (err) => {
          this.setState({
            loading: false,
          });
          Toast.fail("接口错误");
        }
      );
    } else {
      this.setState({
        loading: false,
        subBu: true,
      });
      Toast.fail("* 代表必填项");
      return;
    }
  }

  sub() {
    return (
      <NButton
        style={{ width: "88%", marginLeft: "auto", marginRight: "auto" }}
        onClick={() => {

          if (
            Boolean(
              this.getId("test_requirements") &&
              this.getId("ypjz") &&
              this.getId("dcshl") &&
              this.getId("ypxz") &&
              this.getId("ffck") &&
              this.state.ypsl &&
              this.state.cctj && // 存储条件
              // this.state.jggs && // 结果格式
              this.state.ypjs && // 送样方式
              this.state.yphs && // 样品回收
              this.state.fp_school // 样品回收
            )
          ) {
            Modal.alert("信息核对", (
              <div>
                <div className={styles.item}>
                  <span>样品数量:</span>
                  <span>{this.state.ypsl}</span>
                </div>
                <div className={styles.item}>
                  <span>储存条件:</span>
                  <span>{this.getBuyName("cctj")}</span>
                </div>
                <div className={styles.item}>
                  <span>样品回收:</span>
                  <span>{this.state.yphs}</span>
                </div>
                <div className={styles.item} style={{ marginTop: "unset", lineHeight: "1rem" }}>
                  在您收到结果后样品最多保留两周。
                </div>
                <div style={{ display: "block", marginTop: "10px" }}>
                  <span style={{ float: "left" }}>测试周期:</span>
                  <span
                    style={{ textAlign: 'initial', display: "block" }}>常规测试周期为5-7个工作日，样品数量多、前处理复杂的情况会适当延长。</span>
                </div>


              </div>
            ), [
              {
                text: "返回填写",
                onPress: function () {

                },
                style: { color: "red" }

              },
              {
                text: "确认提交",
                onPress: function () {
                  this.setState({
                    loading: true,
                  });
                  this._sub();
                }.bind(this),
                style: { color: "#333333" },
              },
            ]);
          } else {
            this.setState({
              loading: false,
              subBu: true,
            });
            Toast.fail("* 代表必填项");
            return;
          }


        }}
        title={"提交"}
      />
    );
  }

  page1() {
    return (
      <div style={{ display: this.state.page === 2 && "none" }}>
        {this.info()}

        {this.subject_information()}

        <div className={styles.page}>
          <div></div>
          <NButton
            title={"下一页"}
            style={{ width: "5rem" }}
            onClick={() => {
              if (
                this.getId("name") &&
                this.state.info.phone &&
                this.getId("email") &&
                this.getId("company_name") &&
                // this.getId("company_address") &&
                this.state.info.topic_source &&
                this.getId("topic_name") &&
                this.getId("topic_leader")
              ) {
                console.log(1);
              } else {
                Toast.fail("所有*选项不得为空");
                return;
              }

              let is_phone = checkPhone(this.getId("phone"));
              if (!is_phone) {
                let node = document.getElementById("phone_div");
                console.log("node", node);
                Toast.fail("手机号格式不正确");
                return;
              }
              let is_email = checkEmail(this.getId("email"));
              if (!is_email) {
                Toast.fail("邮箱格式不正确");
                return;
              }
              if (this.getId("email").length > 40) {
                Toast.fail("邮箱最多40个字符");
                return;
              }

              let is_name = checkZE(this.getId("name"));
              if (!is_name) {
                Toast.fail("姓名只允许中英文,最多二十个字");
                return;
              }


              if (!checkZE(this.getId("topic_leader"))) {
                Toast.fail("负责人只允许中英文,最多十个字");
                return;
              }

              let that = this;
              request(
                "index/createInfo",
                {
                  uid: localStorage.getItem("openid"),
                  name: this.getId("name"),
                  phone: this.getId("phone"),
                  email: this.getId("email"),
                  company_name: this.getId("company_name"),
                  // company_address: this.getId("company_address")
                  //   ? this.getId("company_address")
                  //   : "",
                  topic_leader: this.getId("topic_leader"),
                  topic_name: this.getId("topic_name"),
                  topic_source: this.state.info.topic_source,
                },
                ({ data }) => {
                  if (data.code === 1) {
                    that.setState({
                      page: 2,
                    });
                  } else {
                    Toast.fail("个人信息创建失败");
                  }
                }
              );
            }}
          ></NButton>
        </div>
      </div>
    );
  }

  page2() {
    return (
      <div style={{ display: this.state.page === 1 && "none" }}>
        <div className={styles.page}>
          <NButton
            title={"上一页"}
            style={{ width: "5rem" }}
            onClick={() => {
              this.setState({
                page: 1,
              });
            }}
          ></NButton>
          <div></div>
        </div>
        {this.sample()}

        {this.uploadProduct()}

        {this.upload()}

        {this.other()}

        {this.zancun()}

        {this.sub()}
      </div>
    );
  }

  render() {
    return (
      <form style={{ paddingBottom: "20px" }}>
        <Header text="我要送检"></Header>
        <div className={styles.main}>
          {this.page1()}
          {this.page2()}

          <Loading loading={this.state.loading}></Loading>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/AgainOrder.js